export interface Cabinet_Interface {
  id:number,
  title:String,
  dsc:string,
  del:boolean,
  username:string,
  persianDate:string,
}

export function Empty_Cabinet_Interface():Cabinet_Interface{
  return{
    id:0,
    title:'',
    dsc:'',
    del:false,
    username:'',
    persianDate:'',
  }
}
